export default "__VITE_ASSET__Dv49LZUj__"